import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {Betslip} from '../betslip.js';

import {numericKeypadFactory} from './numeric-keypad.factory';

import PALETTE_SCHEMA from './numeric-keypad.palette-schema.yaml';

class NumericKeypadFeature extends AbstractVisualFeature {
    get name() {
        return 'NumericKeypad';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return numericKeypadFactory(PALETTE);
    }
}

new NumericKeypadFeature(Betslip);
